// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_client = require("./MM_wrk_client.bs.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");

var procName = "MM_wrk_LoadCtx";

function beginLoadingMmContext(scopes, onProgress, onDone) {
  MM_wrk_client.beginWorkerInteraction(procName, /* LoadMmContext */{
        scopes: scopes
      }, (function (resp, sendToWorker, endWorkerInteraction) {
          if (resp.TAG === /* MmContextLoadProgress */0) {
            return Curry._1(onProgress, resp.pct);
          }
          Curry._1(endWorkerInteraction, undefined);
          Curry._1(onDone, resp.ctx);
        }), undefined, undefined);
}

function processOnWorkerSide(req, sendToClient) {
  var scopes = req.scopes;
  var totalNumOfAssertions = scopes.reduce((function (a, e) {
          return a + e.expectedNumOfAssertions | 0;
        }), 0);
  var weights = scopes.map(function (s) {
        return s.expectedNumOfAssertions / totalNumOfAssertions;
      });
  try {
    var i = {
      contents: 0
    };
    var len = scopes.length;
    var ctx = MM_context.createContext(undefined, undefined);
    while(i.contents < len) {
      var scope = Caml_array.get(scopes, i.contents);
      var basePct = weights.reduce((function (a, w, idx) {
              if (idx < i.contents) {
                return a + w;
              } else {
                return a;
              }
            }), 0);
      var weight = Caml_array.get(weights, i.contents);
      MM_context.loadContext(Caml_array.get(scopes, i.contents).ast, Caml_option.some(ctx), scope.stopBefore, scope.stopAfter, scope.expectedNumOfAssertions, (function(basePct,weight){
          return function (pct) {
            Curry._1(sendToClient, {
                  TAG: /* MmContextLoadProgress */0,
                  pct: basePct + pct * weight
                });
          }
          }(basePct,weight)), undefined);
      while(MM_context.getNestingLevel(ctx) !== 0) {
        MM_context.closeChildContext(ctx);
      };
      i.contents = i.contents + 1 | 0;
    };
    Curry._1(sendToClient, {
          TAG: /* MmContextLoadProgress */0,
          pct: 1
        });
    return Curry._1(sendToClient, {
                TAG: /* MmContextLoaded */1,
                ctx: {
                  TAG: /* Ok */0,
                  _0: ctx
                }
              });
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === MM_parser.MmException) {
      return Curry._1(sendToClient, {
                  TAG: /* MmContextLoaded */1,
                  ctx: {
                    TAG: /* Error */1,
                    _0: exn._1.msg
                  }
                });
    }
    if (exn.RE_EXN_ID === Js_exn.$$Error) {
      return Curry._1(sendToClient, {
                  TAG: /* MmContextLoaded */1,
                  ctx: {
                    TAG: /* Error */1,
                    _0: Belt_Option.getWithDefault(exn._1.message, "Internal error.")
                  }
                });
    }
    throw exn;
  }
}

exports.procName = procName;
exports.beginLoadingMmContext = beginLoadingMmContext;
exports.processOnWorkerSide = processOnWorkerSide;
/* MM_context Not a pure module */
